import React from "react";

// Container wraps every section in the boxed frame.
// max-w-[1440px], centered, px-5 sm:px-8 md:px-10.
export function SectionFrame({
    children,
    inner = true,
    rounded = "rounded-[28px] sm:rounded-[36px]",
    className = "",
    innerClassName = "",
    as = "section",
    "data-testid": testId,
    ...rest
}) {
    const Tag = as;
    return (
        <Tag
            data-testid={testId}
            className={`w-full mx-auto px-5 sm:px-8 md:px-10 max-w-[1440px] ${className}`}
            {...rest}
        >
            {inner ? (
                <div
                    className={`relative border ${rounded} overflow-hidden ${innerClassName}`}
                    style={{ borderColor: "var(--line)", background: "var(--bg)" }}
                >
                    {children}
                </div>
            ) : (
                children
            )}
        </Tag>
    );
}
